var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{ref:"map",attrs:{"config":_vm.configMap},on:{"wheel":_vm.onWheel,"dragmove":_vm.onDragMove,"dragEnd":_vm.onDragEnd}},[_c('MapBackground',{ref:"mapBg"}),_c('FootprintsWrapper'),_c('MapLabels',{attrs:{"center":_vm.center}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }